import React from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import styled from "styled-components";
import Welcome from "./pages/welcome";
import Editor from "./pages/editor";

const Container = styled.div`
  background: #eee;
  height: 100vh;
`;

function App() {
  return (
    <Router>
      <Container>
        {/* <Header /> */}
        <Route path="/" exact component={Welcome} />
        <Route path="/editor/:projectId" component={Editor} />
      </Container>
    </Router>
  );
}

export default App;
